<template>
	<div class="wrapper flex flex-col justify-center h-full">
		<div class="flex justify-center">
			<div class="w-10/12 sm:w-6/12 md:w-5/12 lg:w-4/12 xl:w-3/12 flex flex-col">
				<img alt="Vue logo" class="w-full p-8" src="../../assets/logo.svg" />
				<div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
					<p class="text-center mb-5 px-5">
						{{ $t('enter_new_password') }}
					</p>

					<div class="mb-4 relative">
						<input
							class="shadow appearance-none input w-full py-2 px-3 pl-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
							id="email"
							type="text"
							:placeholder="$t('e_mail')"
							v-model="email"
							ref="email"
						/>
						<div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
							<div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
								<font-awesome-icon icon="envelope" class="h-5 w-5"></font-awesome-icon>
							</div>
						</div>
					</div>

					<div class="mb-4 relative">
						<input
							class="shadow appearance-none input w-full py-2 px-3 pl-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
							id="password"
							type="password"
							:placeholder="$t('password')"
							v-model="password"
						/>
						<div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
							<div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
								<font-awesome-icon icon="key" class="h-5 w-5"></font-awesome-icon>
							</div>
						</div>
					</div>

					<div class="mb-4 relative">
						<input
							class="shadow appearance-none input w-full py-2 px-3 pl-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
							id="password_confirm"
							type="password"
							:placeholder="$t('repeat_password')"
							v-model="password_confirm"
							@keyup.enter="confirmPassword"
							@input="checkPasswordInput($event)"
						/>
						<div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
							<div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
								<font-awesome-icon icon="key" class="h-5 w-5"></font-awesome-icon>
							</div>
						</div>
					</div>

					<PasswordStrengthMeter class="mb-6" ref="PasswordStrengthMeter" v-model="password_confirm"></PasswordStrengthMeter>
					<div class="text-left">
						<span class="font-bold">{{ $t('least_requirements') }}</span
						><br />
						<ul class="list-disc list-inside ml-4">
							<li>{{ $t('min_eight_chars') }}</li>
							<li>{{ $t('min_one_cap') }}</li>
							<li>{{ $t('min_one_low_char') }}</li>
							<li>{{ $t('min_one_number') }}</li>
							<li>{{ $t('min_one_special') }}</li>
							<li>{{ $t('no_spaces') }} <strong>keine</strong> {{ $t('no_spaces_2') }}</li>
						</ul>
					</div>

					<div class="flex flex-col md:flex-row items-center justify-end mt-4">
						<BaseButton :disabled="!isSaveAllowed" @click="confirmPassword" class="btn-blue">{{ $t('general.save') }}</BaseButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import apiDefaults from '@/api/defaultConfiguration';
import { AuthenticationApiFactory } from '@/api/generated';
import { _regxp } from '@/plugins/Utils';
import PasswordStrengthMeter from '@/components/damagecases/forms/PasswordStrengthMeter';
import BaseButton from '@/components/forms/buttons/BaseButton';
import AuthRepository from '@/api/repositories/AuthRepository';

export default {
	name: 'ConfirmPassword',
	components: { PasswordStrengthMeter, BaseButton },
	data() {
		return {
			email: this.$route.query.email,
			password: '',
			password_confirm: '',
			token: this.$route.query.token,
			regxp: _regxp(),
			isSaveAllowed: true,
		};
	},
	mounted() {
		const input = this.$refs.email;
		input.focus();
	},
	methods: {
		confirmPassword() {
			const match = this.email.match(this.regxp.email);
			if (!(match !== null && match[0] === this.email)) {
				this.$swal(this.$t('general.attention').toString(), this.$t('check_e_mail').toString(), 'error');
			} else {
				if (this.password !== this.password_confirm) {
					this.$swal(this.$t('general.attention').toString(), this.$t('passwords_dont_match').toString(), 'error');
				} else {
					const data = {
						email: this.email,
						password: this.password,
						token: this.token,
					};

					const request =
						this.$route.query.type === 'customer'
							? new AuthRepository().changeForgotPassword(data, 'customer')
							: AuthenticationApiFactory(
									apiDefaults.config(),
									apiDefaults.basePath,
									apiDefaults.axios,
							  ).changePasswordPost(data);

					return request
						.then(response => {
							this.$swal(
								this.$t('general.success').toString(),
								this.$t('password_changed_successfully').toString(),
								'success',
							).then(() => {
								this.$router.push({ name: 'login' });
							});
						})
						.catch(error => {
							this.$swal(
								this.$t('general.error').toString(),
								this.$t('password_require_new_link').toString(),
								'error',
							).then(() => {
								this.$router.push({ name: 'login' });
							});
						});
				}
			}
		},
		checkPasswordInput: function() {
			const pwCheck = this.checkPasswordStrength(this.password_confirm);
			this.isSaveAllowed = !(this.password_confirm !== '' && pwCheck < 5);
			// TODO entfernen, wenn Produktiv!
			// this.isSaveAllowed = true;
		},
		checkPasswordStrength: function($event) {
			return this.$refs['PasswordStrengthMeter'].checkPasswordStrength($event);
		},
	},
};
</script>

<style lang="sass" scoped>
.wrapper
  background-color: #e9ecef
</style>
